import { useLocale } from "../../i18n/LocaleContext";
import { productCategories } from "../../data/productCategories";
import ProductCategoryIcon from "./ProductCategoryIcon";
import "./index.css";

function ProductCategoryNav({
  activeCategory,
  onChange,
  className = "",
  categories = productCategories,
}) {
  const { t } = useLocale();

  return (
    <div className={`product-category-nav ${className}`.trim()} role="tablist">
      {categories.map((item) => {
        const isActive = activeCategory === item.id;

        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-label={t(item.labelKey)}
            className={`product-category-nav__item ${isActive ? "is-active" : ""}`}
            onClick={() => onChange(item.id)}
          >
            <span className="product-category-nav__icon" aria-hidden="true">
              <ProductCategoryIcon type={item.id} />
            </span>
            <span className="product-category-nav__dot" aria-hidden="true" />
            <span className="product-category-nav__label product-category-nav__label--full" aria-hidden="true">
              {t(item.labelKey)}
            </span>
            <span className="product-category-nav__label product-category-nav__label--short" aria-hidden="true">
              {t(item.navLabelKey || item.labelKey)}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default ProductCategoryNav;
